import { Contact } from '../../common/interfaces';
import { isArray } from 'rxjs/internal-compatibility';

export const MAX_CONTACT_OPTIONS = 100;

export const checkIfOnDemandOptionsShouldBeEnabled = (contacts: Contact[] | null | undefined) => {
    return contacts != null && isArray(contacts) && contacts.length >= MAX_CONTACT_OPTIONS;
};
